exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body[data-v-419f1b19] {\n  text-align: center;\n}\n.modal-body-message[data-v-419f1b19] {\n  padding-bottom: 0;\n}", ""]);

// exports
